<div nz-row *transloco="let t; prefix: 'organizations.detailPage';">
  <aad-title [title]="t('tab.communication')" />
  <div nz-col nzSpan="24">
    <aml-filter />
  </div>
  <div nz-col nzSpan="24">
    <aml-datatable
      [dataSource]="facade.emails()"
      [columns]="facade.tableColumns()"
      [isLoading]="facade.isLoading()"
      [hasMore]="facade.hasMore()"
      [showToolbar]="false"
      (queryParamsChange)="loadDataFromServer($event)"
      (actualTableConfiguration)="saveTableConfiguration($event)"
    />
  </div>
</div>
